import {useState} from 'react';

// Rows an analyst has set aside on a submission page, keyed by the page's own row key. A dismissed
// row stays on screen (greyed out) so it can be restored, but is left out of Classify all and
// Flag all. Purely local to the page: nothing is saved, and starting a new batch clears it.
export function useDismissedKeys() {
  const [dismissed, setDismissed] = useState<ReadonlySet<string>>(new Set());

  const setKey = (key: string, value: boolean) => {
    setDismissed((previous) => {
      if (previous.has(key) === value) {
        return previous;
      }

      const next = new Set(previous);
      if (value) {
        next.add(key);
      } else {
        next.delete(key);
      }

      return next;
    });
  };

  return {
    isDismissed: (key: string) => dismissed.has(key),
    dismiss(key: string) {
      setKey(key, true);
    },
    restore(key: string) {
      setKey(key, false);
    },
    clear() {
      setDismissed(new Set());
    }
  };
}
